import React, { PropsWithChildren, ReactElement } from 'react';
import cn from 'utils/cn';

interface TProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  testId: string;
}

const ActionButton: React.FC<TProps & PropsWithChildren> = ({
  testId = 'action-button',
  type = 'button',
  children,
  ...rest
}): ReactElement<any> => {
  return (
    <button
      {...rest}
      type={type}
      data-testid={testId}
      className={cn(
        'tw:!text-sm tw:px-3 tw:border-t-0 tw:border-b-0 tw:border-r-0 tw:border-l tw:border-secondary-100 tw:flex tw:items-center tw:h-[40px] tw:bg-transparencies-1005 tw:text-inherit',
        rest?.disabled ? 'tw:opacity-50' : 'tw:cursor-pointer tw:hover:bg-transparencies-10025',
        rest.className
      )}
      style={rest?.style}
    >
      {children}
    </button>
  );
};

export default ActionButton;
